module.exports = __webpack_public_path__ + "img/189.5d57f7f0.jpg";